<template>
  <div>
    <div class="d-flex flex-wrap" v-if="edit">
      <div v-for="s in list" :key="s">
        <div>
          <label>{{ s }}</label
          ><button
            type="button"
            class="ml-2 mr-3 btn-sm btn-outline-dark"
            @click="remove(s)"
          >
            -
          </button>
        </div>
      </div>
      <input type="text" @keyup.enter="add()" v-model="inputValue" />
      <button
        type="button"
        class="ml-2 btn btn-sm btn-outline-dark"
        @click="add()"
      >
        +
      </button>
    </div>
    <div v-if="!edit">
      <p>{{ asString }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "stringlist",
  data: function() {
    return {
      inputValue: ""
    };
  },
  watch: {},
  methods: {
    add() {
      console.info("add");
      this.inputValue = this.inputValue.trim();
      let index = this.list.indexOf(this.inputValue);
      if (index < 0 && this.inputValue !== "") {
        this.list.push(this.inputValue);
        this.inputValue = "";
      }
    },
    remove(value) {
      console.info("remove");
      let index = this.list.indexOf(value);
      if (index >= 0) {
        this.list.splice(index, 1);
      }
    }
  },
  props: {
    list: Object,
    edit: Boolean
  },
  computed: {
    asString() {
      return this.list.join(", ");
    }
  }
};
</script>
